// extracted by mini-css-extract-plugin
export default {"price":"Zoa-z","onSale":"_oa-z","msrpLabelPrice":"apa-z","msrpLabel":"bpa-z","originalPrice":"cpa-z"};